import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, timeout: 20000 });

let _lang = (() => { try { return localStorage.getItem("dv_lang") || "fr"; } catch { return "fr"; } })();
export const setMoneyLang = (l) => { _lang = l; };
const lang = () => _lang;

export const api = {
  demoGoal: () => http.get("/demo/goal").then((r) => r.data),
  parseIntent: (text, current) => http.post("/ai/parse-intent", { text, current }).then((r) => r.data),
  recommendations: (goal = {}) => http.post(`/trips/recommendations`, { budget: 2500, ...goal, lang: lang() }).then((r) => r.data),
  allTrips: (budget = 2500) => http.get(`/trips`, { params: { budget, lang: lang() } }).then((r) => r.data),
  destinations: () => http.get("/destinations").then((r) => r.data),
  trip: (id, budget = 2500) => http.get(`/trips/${id}`, { params: { budget, lang: lang() } }).then((r) => r.data),
  aiTake: (trip_id, budget = 2500) => http.post("/ai/take", { trip_id, lang: lang(), budget }).then((r) => r.data),
  watchlist: () => http.get("/watchlist").then((r) => r.data),
  addWatch: (trip_id) => http.post("/watchlist", { trip_id }).then((r) => r.data),
  removeWatch: (trip_id) => http.delete(`/watchlist/${trip_id}`).then((r) => r.data),
  simulateOpportunity: () => http.post("/watchlist/simulate-opportunity", null, { params: { lang: lang() } }).then((r) => r.data),
  journey: () => http.get("/journey", { params: { lang: lang() } }).then((r) => r.data),
  simulateDisruption: () => http.post("/journey/simulate-disruption", null, { params: { lang: lang() } }).then((r) => r.data),
  resetDemo: () => http.post("/demo/reset").then((r) => r.data),
  analysis: (goal = {}) => http.post("/analysis", { budget: 2500, ...goal, lang: lang() }).then((r) => r.data),
  evaluate: (payload) => http.post("/evaluate", { ...payload, lang: lang() }).then((r) => r.data),
  evaluateParse: (text) => http.post("/evaluate/parse", { text }).then((r) => r.data),
  addWatchCustom: (payload) => http.post("/watchlist/custom", payload).then((r) => r.data),
  watchTimeline: () => http.get("/watchlist/timeline", { params: { lang: lang() } }).then((r) => r.data),
  loyaltyGoal: () => http.get("/loyalty/goal").then((r) => r.data),
  loyaltyEvaluate: (payload) => http.post("/loyalty/evaluate", { ...payload, lang: lang() }).then((r) => r.data),
  xpSearch: (payload) => http.post("/xp/search", payload, { timeout: 90000 }).then((r) => r.data),
  searchLive: (goal = {}) => http.post("/search/live", { budget: 2500, ...goal, lang: lang() }, { timeout: 45000 }).then((r) => r.data),
  searchTripsLive: (goal = {}) => http.post("/search/trips/live", { budget: 2500, ...goal, lang: lang() }, { timeout: 60000 }).then((r) => r.data),
};

export const eur = (n) => {
  const v = Number(n);
  if (_lang === "fr") return `${v.toLocaleString("fr-FR")} €`;
  return `€${v.toLocaleString("en-US")}`;
};
